import { render, staticRenderFns } from "./changePass.vue?vue&type=template&id=59f8520b&"
import script from "./changePass.vue?vue&type=script&lang=js&"
export * from "./changePass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports